import { render, staticRenderFns } from "./QnaWrite.vue?vue&type=template&id=51defe04"
import script from "./QnaWrite.vue?vue&type=script&lang=js"
export * from "./QnaWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports